import Grid from "@mui/material/Grid";

import { ConnectStripeButton } from "../../../../features/Stripe/ConnectStripeButton";
import { useTranslate } from "../../../../hooks/useTranslate";

import { DashboardInfobox } from "@/dashboard-design-system/Infobox";

export const StripeEmailAlert = ({ message }: { message?: string }) => {
  const { t } = useTranslate();

  return (
    <DashboardInfobox
      vibe="warning"
      size="small"
      type="alert"
      customButton={
        <ConnectStripeButton variant="tonal" vibe="warning" sx={{ marginLeft: 1 }}>
          {t("dashboard", "bank.connectMyBankAccount")}
        </ConnectStripeButton>
      }
    >
      <Grid container justifyContent="space-between">
        <Grid item alignContent="center">
          {t("dashboard", "common.mustCompleteBankToEnableEmailing")}
          {message ? message : t("dashboard", "common.mustCompleteBankToEnableEmailing.reason")}{" "}
          {t("dashboard", "writeEmailModal.pleaseValidateYourEmail2")}
        </Grid>
      </Grid>
    </DashboardInfobox>
  );
};
